import _ from 'lodash'
function fireMouseEvents(element, eventNames = ['mousedown']) {
	// we stole this from SO to emulate mousedown/other non-click mouse events
	if (element && eventNames && eventNames.length) {
		for (const index in eventNames) {
			const eventName = eventNames[index]
			if (element.fireEvent) {
				element.fireEvent('on' + eventName)
			} else {
				const eventObject = document.createEvent('MouseEvents')
				eventObject.initEvent(eventName, true, false)
				element.dispatchEvent(eventObject)
			}
		}
	}
}

const findInput = field => {
	const child = field.querySelector('input') || field.querySelector('textarea') // for now, we assume the 'actual' input is always an input AND there is always only one

	child?.focus()
}

const findDatePickerTrigger = (field, {open}) => {
	if (open) return

	const trigger = field.querySelector('.date-picker-field-trigger')

	if (!trigger) return
	trigger.click()
}

const findTimePickerTrigger = (field, {open}) => {
	if (open) return

	const trigger = field.querySelector('.time-picker-field-trigger')

	if (!trigger) return
	trigger.click()
	trigger.focus()
}

const findLegacyDatePickerTrigger = (field, {open}) => {
	if (open) return false

	const innerInput = field.querySelector('input')

	if (!innerInput) return false
	innerInput.click()
}

const clickListPickerTrigger = (field, {open}) => {
	const child = field.querySelector('.form-trigger-container')
	if (!open) child.click()
}

const clickSelectTrigger = (field, {open}) => {
	const el = field.querySelector('.select-trigger-container')
	if (!open) el.click()
}

const clickSwitchInnerInput = (field, {event}) => {
	// Ark already handles clicks inside the switch; only delegate clicks from the surrounding form row.
	if (event.target.closest?.('.switch')) return

	// Targeting the hidden input instead to prevent Ark shifting focus to the switch component
	const input = field.querySelector('input[type="checkbox"]')
	input?.click()
}

const clickCheckboxInnerInput = (field, {event}) => {
	// If the click was triggered in the checkbox itself, return early to prevent double click
	if (event.target.closest?.('.checkbox-root')) return

	// Click the native input directly so the field-row click toggles the checkbox without moving focus.
	const input = field.querySelector('input[type="checkbox"]')
	input?.click()
}

const findDefault = field => {
	const child = field.querySelector('input')
	child?.focus?.()
	fireMouseEvents(child)
}

const clickChild = field => {
	const child = field.querySelector('input')
	child?.click?.()
}

const clickPopoutCard = (field, {open}) => {
	const child = field.querySelector('.popout-card-trigger')
	if (!open) child?.click?.()
}

const clickColorPickerTrigger = (field, {open}) => {
	const child = field.querySelector('.color-preview')
	if (!open) child?.click?.()
}

export const findFns = {
	'eitje-sentence-picker-container': _.noop,
	'eitje-input-container': findInput,
	'time-picker-field': findTimePickerTrigger,
	'date-picker-field': findDatePickerTrigger,
	'eitje-legacy-date-picker-container': findLegacyDatePickerTrigger,
	'eitje-list-picker': clickListPickerTrigger,
	'eitje-select': clickSelectTrigger,
	'switch-field': clickSwitchInnerInput,
	'checkbox-field': clickCheckboxInnerInput,
	'eitje-avatar-picker': clickChild,
	'eitje-asset-picker': clickChild,
	'eitje-team-color-picker': clickPopoutCard,
	'eitje-color-picker': clickColorPickerTrigger,
	default: findDefault,
}
